<template>
  <div>
    <page-header
      :actions="headerActionConfig"
      left-side-class="col-xl-5 pb-2"
      :page="headerConfig"
      right-side-class="col-xl-7 d-flex align-items-end pb-4 justify-content-end"
    />
    <rubric-form v-model="rubric" :is-read-only="isReadOnly" />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import { getById, publish, rollbackToDraft } from '@/modules/rubric/api.js';
import alert from '@/mixins/alert.mixin';
import RubricForm from '@/components/common/rubric/form/RubricForm.vue';

import RubricStatus from '@/utils/shared/constants/rubricStatus.js';

export default {
  name: 'RubricPreview',
  components: {
    PageHeader,
    RubricForm,
  },
  mixins: [alert],
  data() {
    return {
      rubric: {},
    };
  },
  computed: {
    headerConfig() {
      return {
        title: 'Formulario de Evaluación de Propuestas',
        icon: 'fas fa-user fa-xs',
        routes: [
          'Proceso de Competencias',
          'Formulario de Evaluación de Propuestas',
        ],
      };
    },
    headerActionConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'far fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.push({ name: 'RubricSetting' }),
        },
        {
          text: 'Regresar a Borrador',
          icon: 'fas fa-reply-all',
          variant: 'outline-success',
          visible: this.canRollbackDraft,
          click: () => this.rollbackToDraft(),
        },
        {
          text: 'Publicar',
          icon: 'fas fa-file-check',
          variant: 'success',
          visible: this.canPubish,
          click: () => this.publish(),
        },
      ];
    },
    id() {
      const { id } = this.$route.params;
      return Number(id);
    },
    isDraft() {
      return this.rubric.status?.id === RubricStatus.Draft;
    },
    isSubmitted() {
      return this.rubric.status?.id === RubricStatus.Submitted;
    },
    isPublished() {
      return this.rubric.status?.id === RubricStatus.Published;
    },
    isReadOnly() {
      return [RubricStatus.Draft, RubricStatus.Published].includes(
        this.rubric.status?.id
      );
    },
    canPubish() {
      return (
        this.userHasPermissions('provider.rubricsettings.publish') &&
        this.isSubmitted
      );
    },
    canRollbackDraft() {
      return (
        this.userHasPermissions('provider.rubricsettings.rollback.draft') &&
        this.isSubmitted
      );
    },
  },
  async mounted() {
    await this.getRubric();
  },
  methods: {
    async getRubric() {
      const { data } = await getById(this.id).catch((e) =>
        this.ShowToast('', e?.response?.data?.message, 'error')
      );
      const { sections, additionalQuestions } = data;
      const questions = sections.flatMap((s) => s.questions);
      additionalQuestions.forEach((q) => (q.value = null));
      questions.forEach((q) => (q.value = null));
      this.rubric = data;
    },
    async publish() {
      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea publicar la rúbrica <b>${this.rubric.number}</b>?`,
        'Sí',
        'No'
      );

      if (!confirmed) return;

      await publish(this.id)
        .then(() => this.getRubric())
        .catch((e) => this.ShowToast('', e?.response?.data?.message, 'error'));

      this.ShowToast(
        'Proceso exitoso',
        'Los cambios fueron guardados exitosamente',
        'success'
      );
    },
    async rollbackToDraft() {
      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea regresar la rúbrica a borrador?',
        'Sí',
        'No'
      );

      if (!confirmed) return;
      this.ShowToast(
        'Proceso exitoso',
        'Los cambios fueron guardados exitosamente',
        'success'
      );
      await rollbackToDraft(this.id)
        .then(() => {
          this.$router.push({ name: 'RubricEdit', params: { id: this.id } });
        })
        .catch((e) => this.ShowToast('', e?.response?.data?.message, 'error'));
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/brand_variables.scss';
.section-title > div {
  border: 3px solid white;
  padding: 3px 4px;
  border-radius: 30px;
  -webkit-box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
}
</style>
